import React from 'react';
import { Button } from './ui/button';

const ActivityPills = ({ currentActivity, onActivityChange }) => {
  const activities = [
    { id: 'walk', label: 'Walk', icon: '🚶‍♂️' },
    { id: 'run', label: 'Run', icon: '🏃‍♂️' },
    { id: 'cycle', label: 'Cycle', icon: '🚴‍♂️' },
    { id: 'travel', label: 'Travel', icon: '✈️' }
  ];

  return (
    <div className="flex justify-center gap-2 flex-wrap">
      {activities.map((activity) => (
        <Button
          key={activity.id}
          variant={currentActivity === activity.id ? "default" : "outline"}
          size="sm"
          onClick={() => onActivityChange(activity.id)}
          className="flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-200"
        >
          <span className="text-base">{activity.icon}</span>
          <span className="font-medium">{activity.label}</span>
        </Button>
      ))}
    </div>
  );
};

export default ActivityPills;